// @needs-native-review — best-effort translation
import type { Translations } from '../types';

export const th: Translations = {
  'meta.gameTitle': 'Luminary',

  'howto.title': 'วิธีเล่น',
  'howto.pieces.heading': 'ชิ้นส่วน',
  'howto.pieces.source': 'แหล่งกำเนิด',
  'howto.pieces.mirror': 'กระจก',
  'howto.pieces.switch': 'สวิตช์',
  'howto.pieces.exit': 'ทางออก',
  'howto.pieces.wall': 'กำแพง',
  'howto.controls.heading': 'การควบคุม',
  'howto.controls.clickSlot.line1': 'คลิกช่อง',
  'howto.controls.clickSlot.line2': 'วางกระจก',
  'howto.controls.dragMirror.line1': 'ลากกระจก',
  'howto.controls.dragMirror.line2': 'หมุน',
  'howto.controls.rightClick.line1': 'คลิกขวา',
  'howto.controls.rightClick.line2': 'เอากระจกออก',
  'howto.controls.hint': 'ล้อเมาส์: หมุนละเอียดทีละ 1°   แตะกระจก: หมุนทีละ 15°',
  'howto.objective.line1': 'จุดสวิตช์ทุกอันให้ติด — ล็อกทางออกจะเปิดเอง',
  'howto.objective.line2': 'จากนั้นคลิกทางออก แก้ปริศนาด้วยกระจกให้น้อยที่สุด',

  'howtoColor.title': 'สีและปริซึม',
  'howtoColor.pieces.heading': 'ชิ้นส่วนใหม่',
  'howtoColor.pieces.prism': 'ปริซึม',
  'howtoColor.pieces.redSwitch': 'สวิตช์แดง',
  'howtoColor.pieces.yellowSwitch': 'สวิตช์เหลือง',
  'howtoColor.pieces.whiteSwitch': 'สวิตช์ขาว',
  'howtoColor.how.heading': 'มันทำงานอย่างไร',
  'howtoColor.how.line1': 'ลำแสงสีขาวพาแสงแดง เขียว และน้ำเงินไปพร้อมกัน',
  'howtoColor.how.line2': 'ปริซึมแยกแสงขาวออกเป็นลำแสงสามสีไปตามสามด้านของมัน',
  'howtoColor.how.line3': 'คลิกปริซึมที่วางไว้เพื่อหมุนด้านรับแสงของมัน',
  'howtoColor.switches.line1': 'สวิตช์มีจุดสี — นั่นคือสีที่มันต้องการ',
  'howtoColor.switches.line2': 'สวิตช์เหลือง (จุดแดง + เขียว) ต้องการทั้งสองสีพร้อมกัน',
  'howtoColor.switches.line3': 'สวิตช์ขาว (ครบสามสี) ต้องการแดง เขียว และน้ำเงินพร้อมกัน',

  'options.hints.label': 'แสดงมุมคำใบ้ในปริศนา',
  'options.hints.help': 'แสดงมุมระหว่างลำแสงที่ตกกระทบกับลำแสงสะท้อนที่จุดสะท้อนทุกจุด',

  'level.01-intro.title': 'สวัสดีแสง',
  'level.02-two-mirrors.title': 'สองโค้ง',
  'level.03-corner.title': 'กำแพงขวางทาง',
  'level.04-two-targets.title': 'สองเป้าหมาย',
  'level.05-tight.title': 'คับแคบ',
  'level.06-hello-color.title': 'สวัสดีสี',
  'level.07-pick-a-side.title': 'เลือกข้าง',
  'level.08-yellow.title': 'เหลือง',
  'level.09-magenta.title': 'ม่วงแดง',
  'level.10-spectrum.title': 'สเปกตรัม',

  // PuzzleScene
  'puzzle.itemCounter': '{used}/{optimal}',
  'puzzle.hint.angleType.right': 'ฉาก',
  'puzzle.hint.angleType.acute': 'แหลม',
  'puzzle.hint.angleType.obtuse': 'ป้าน',
  'puzzle.hint.label': '{angle}°\n{type}',
};
